const settings = {
  apiUrl: "https://gosapi.draftplaza.com",
  GOS_LOBBY_URL: "https://goslobby.draftplaza.com",
  reportUrl: "https://reports.draftplaza.com",
  SILVER_HOME_URL: "https://apps2.pokerplaza.com/coinbar",
  SOCKET_URL: [
    "https://goswsp2.draftplaza.com",
    "https://goswsp1.draftplaza.com",
  ],
  ACCOUNTING_API: "https://webapi.draftplaza.com",
  MEDIA_URL: "https://webapi.draftplaza.com/api",
  FILE_STORAGE_ADDRESS: "https://strapi4mggos.draftplaza.com",
  LOBBY: "https://webapi.draftplaza.com",
  GAME_BOX_URL: "https://stg-funbonus-gamebox.draft10.com",
};

export default settings;
